import { Howl } from 'howler';

export const fadeOutStop = (sound: Howl, duration = 2000) => {
  if (!sound || !sound.playing()) return;
  const fromVolume = sound.volume();
  // 1. Start Fade
  sound.fade(fromVolume, 0, duration);

  // 2. Wait for fade to complete
  sound.once('fade', () => {
    sound.stop();
    // 3. Reset volume immediately so next play isn't silent
    sound.volume(fromVolume);
  });
};

export const fadeInPlay = (sound: Howl, duration = 2000) => {

  const defaultVolume = sound.volume();

  // 1. Set volume to 0 immediately (silence)
  sound.volume(0);

  // 2. Start playing (you won't hear anything yet)
  const id = sound.play();

  // 3. Ramp volume from 0 to 1.0 over 'duration' milliseconds
  sound.fade(0, defaultVolume, duration, id);
};
